import React from 'react';
import { Alert } from 'react-bootstrap';
import { useActionData } from 'react-router-dom';
import { motion } from 'framer-motion';

const FormResultMessage: React.FC = () => {
  const actionData = useActionData<{ success?: boolean; error?: string }>();

  const fadeProps = {
    initial: { opacity: 0, y: -10 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8 },
  };

  if (actionData?.success) {
    return (
      <motion.div {...fadeProps}>
        <Alert variant="success" className="text-center py-2 m-4">
          Your referral was submitted successfully!
        </Alert>
      </motion.div>
    );
  }

  if (actionData?.success === false && actionData.error) {
    return (
      <motion.div {...fadeProps}>
        <Alert variant="danger" className="text-center py-2 m-4">
          {actionData.error}
        </Alert>
      </motion.div>
    );
  }

  return null;
};

export default FormResultMessage;
